import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const brandsList = (theme: Theme) => css`
  border: 1px solid ${theme.system.borderBase};
  width: 100%;
`;

export const boxSection = css`
  @media (min-width: ${dimensions.tablet}) {
    padding: 1rem 2rem;
  }
`;

export const header = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
  min-height: 2.75rem;
  &&& {
    margin-bottom: 1rem;
  }
`;

export const title = (theme: Theme) => css`
  display: flex;
  align-items: center;
  color: ${theme.text.body};
  &&& {
    margin-bottom: 0;
  }
`;

export const titleHighlighted = (theme: Theme) => css`
  color: ${theme.success.textBase};
  margin-left: 0.25rem;
`;

export const carouselSelector = css`
  width: 100%;
  text-align: right;
  display: flex;
  justify-content: flex-end;
`;
